import * as clMain from './js/main';
import { getDate } from "../admin/js/utils/utils";
// 
import './css/cl-styles.css';
import '../admin/css/custom-font.css';
// 
// console.log(`%cHello World from Public, today is ${getDate()}`, 'background: blue; font-size: 16px;');

window.addEventListener('load', (e) => {
    window.clsGlobalObj = {
        ...clMain
    };
    // LOAD IFRAME
    window.clsGlobalObj.importIframeEvents();
});
